import INVENTORY_API_BASE_URL from "../../config/api";
import "./manageaqssets.css";
import Axios from "axios";
import { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";

import logUserActivity from "../utils/logUserActivity";

function Manageassets() {
  const [data, setData] = useState([]);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedValues, setEditedValues] = useState({});
  const [originalValues, setOriginalValues] = useState({});

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getAssets`).then((response) => {
      setData(response.data);
    });
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const calculateTotalValue = (quantity, price) => {
    if (!quantity || !price) return "";
    return quantity * price;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedValues({ ...editedValues, [name]: value });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditedValues(data[index]);
    setOriginalValues(data[index]);
  };

  const cancelbutton = async () => {
    window.location.reload();
  };

  const handleSave = async () => {
    try {
      await Axios.put(
        `${INVENTORY_API_BASE_URL}/editManageassets/${editedValues._id}`,
        editedValues
      );

      const updatedFields = {};
      Object.keys(editedValues).forEach((key) => {
        if (editedValues[key] !== originalValues[key]) {
          updatedFields[key] = {
            old: originalValues[key],
            new: editedValues[key],
          };
        }
      });

      await logUserActivity("EDIT_ASSET", {
        assetId: editedValues._id,
        updatedFields,
      });

      setEditingIndex(-1);
      setEditedValues({});
      setOriginalValues({});
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="manageassets-wrapper">
      <h5 className="manageassets-container"></h5>

      <h3 style={{ textAlign: "center", marginTop: "3rem" }}>Manage Assets</h3>
      <div style={{ overflowX: "auto", width: "100%", display: "block" }}>
        <br />
        <Table
          responsive
          style={{
            minWidth: "1300px",
            width: "100%",
            border: "1px solid #ccc",
            borderCollapse: "collapse",
            fontSize: "14px",
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            borderRadius: "8px",
          }}
        >
          <thead>
            <tr style={{ background: "#f7f9fc", textAlign: "center" }}>
              {[
                "Assets Name",
                "Description",
                "Category",
                "Assets Tag",
                "Serial Number",
                "Purchase Date",
                "Warranty Date",
                "Quantity",
                "Price",
                "Total Value",
                "Download Link",
                "Action",
              ].map((text, i) => (
                <th
                  key={i}
                  style={{
                    padding: "12px 10px",
                    borderBottom: "2px solid #eee",
                    whiteSpace: "nowrap",
                    fontWeight: "600",
                    color: "#333",
                    borderRight: "1px solid #eee",
                  }}
                >
                  {text}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              const isEditing = editingIndex === index;
              return (
                <tr
                  key={row._id}
                  style={{
                    textAlign: "center",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {[
                    "Assets",
                    "Description",
                    "Category",
                    "assetsTag",
                    "Serialno",
                    "Date",
                    "Warranty",
                    "Quantity",
                    "price",
                  ].map((field) => (
                    <td
                      key={field}
                      style={{
                        padding: "10px",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #eee",
                      }}
                    >
                      {isEditing ? (
                        <input
                          name={field}
                          value={editedValues[field] || ""}
                          onChange={handleInputChange}
                          style={{
                            width: "100%",
                            padding: "6px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        />
                      ) : field === "Date" || field === "Warranty" ? (
                        formatDate(row[field])
                      ) : (
                        row[field]
                      )}
                    </td>
                  ))}
                  <td
                    style={{
                      padding: "10px",
                      whiteSpace: "nowrap",
                      borderRight: "1px solid #eee",
                    }}
                  >
                    {isEditing
                      ? calculateTotalValue(
                          editedValues.Quantity,
                          editedValues.price
                        )
                      : calculateTotalValue(row.Quantity, row.price)}
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      whiteSpace: "nowrap",
                      borderRight: "1px solid #eee",
                    }}
                  >
                    {row.InvFile ? (
                      <a
                        href={`${INVENTORY_API_BASE_URL}/${row.InvFile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                        }}
                      >
                        {row.InvFile.endsWith(".pdf")
                          ? "Open PDF"
                          : "Open Image"}
                      </a>
                    ) : (
                      "Not Uploaded"
                    )}
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      whiteSpace: "nowrap",
                      borderRight: "1px solid #eee",
                    }}
                  >
                    {isEditing ? (
                      <>
                        <button
                          style={{
                            margin: "2px",
                            padding: "6px 12px",
                            borderRadius: "4px",
                          }}
                          className="btn btn-success"
                          onClick={handleSave}
                        >
                          Save
                        </button>
                        <button
                          style={{
                            margin: "2px",
                            padding: "6px 12px",
                            borderRadius: "4px",
                          }}
                          className="btn btn-secondary"
                          onClick={cancelbutton}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        style={{
                          margin: "2px",
                          padding: "6px 12px",
                          borderRadius: "4px",
                        }}
                        className="btn btn-primary"
                        onClick={() => handleEdit(index)}
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default Manageassets;
